export class Allegato {
	constructor(public tipoFile: string) {}
	nomeFile?: string;
	nomeAllegato?: string;
	tipoAllegato?: string;
	descrizione?: string;
	urlAllegato?: string;
}